import React from 'react';
import createReactClass from 'create-react-class';
import { Link } from 'react-router-dom';
import Formsy from 'formsy-react';
import SubmitButton from './SubmitButton';
import ReactDOM from 'react-dom';
import formDataToObject from 'form-data-to-object';

const Form = createReactClass({
  getDefaultProps() {
    return {
      submitButtonTitle: 'Speichern',
      backButtonLink: '/',
      showBackButton: true,
      footer: null,
      isAjaxInProgress: false,
      onValidate: () => {},
    };
  },

  getInitialState() {
    return {
      isValid: false
    };
  },

  focus(name, doSelect) {
    let component = this.form.inputs[name];
    if(!component) {
      console.warn('Form does not contain an input "' + name + '", cannot focus.');
      return;
    }

    let domNode = ReactDOM.findDOMNode(component);
    let input = domNode.querySelector('input');

    if(!input) {
      console.warn('Could not retrieve input element with id "' + name + '", cannot focus.');
      return;
    }

    input.focus();
    if(doSelect) {
      input.select();
    }
  },

  focusAndSelect(name) {
    this.focus(name, true);
  },

  getModel() {
    var currentValues = this.form.getCurrentValues();
    return this.mapModel(currentValues);
  },

  mapModel(model) {
    return formDataToObject(Object.keys(model).reduce((mappedModel, key) => {
      var keyArray = key.split('.');
      var base = mappedModel;
      while (keyArray.length) {
        var currentKey = keyArray.shift();
        base = (base[currentKey] = keyArray.length ? base[currentKey] || {} : model[key]);
      }

      return mappedModel;

    }, {}));
  },

  validateForm() {
    this.form.validateForm();
  },

  reset() {
    this.form.reset();
  },

  render() {
    const { sendToServer, children, linkBack, submitButtonTitle, ...props} = this.props;

    let footer = this.props.footer;

    if(!footer) {
      footer = (
          <footer>
            {this.props.showBackButton ?
              (<Link to={this.props.backButtonLink} className="btn btn-default">Zurück</Link>) :
              (<span/>)}

            <SubmitButton canSubmit={this.state.isValid && !this.props.isAjaxInProgress} title={this.props.submitButtonTitle} />
          </footer>
      );
    }

    return (
      <Formsy.Form ref={c => this.form = c}
        className="smart-form"
        onSubmit={this.props.onSubmit}
        onValid={() => this.setState({isValid: true}, () => this.props.onValidate(this.state.isValid))}
        onInvalid={() => this.setState({isValid: false}, () => this.props.onValidate(this.state.isValid))}
        {...props}>

        {children}

        {footer}
      </Formsy.Form>
    );
  }

});

export default Form;



// WEBPACK FOOTER //
// ./src/components/common/Forms/Form.js